module.exports = __webpack_public_path__ + "static/img/noOrder.e228823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noOrder.png
// module id = k7Ys
// module chunks = 1